import planPeriodicities from '@/util/planPeriodicities'

export default function () {
  return {
    planPeriodicities,
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    errors: {},
    plan: {
      id: null,
      name: '',
      value: 0,
      periodicity: '',
      enabled: true,
      maxInstallments: 1,
    },
  }
}
